import { getAdvanceDriverCategory, getChartExpense, getExpense, getUserAccountList, handleKeyDown, uploadFiles } from "_services";
import {
  CommonCanvas,
  CommonDatePicker,
  CommonInput,
  CommonModal,
  CrossButton,
  CustomSelect,
  LoaderButton,
  SkeletonInput,
} from "components";
import { UserContext } from "context";
import { addDriverTransaction, addTransationConsignor } from "features";
import { errorSchema, utils } from "helper";
import AddAccountingAccount from "modals/AddAccountingAccount";
import PayNowAccountNotifyModal from "modals/PayNowAccountNotifyModal";
import moment from "moment";
import Loading from "pages/Loading";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { IoCloseCircle } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { getAllPermissions } from "utils/permissionHelper";
import StorageService from "utils/StorageServices/StorageServices";

const PayDriver = (props) => {
  const { callBackFreight, closeModal, isOpen, venderDetailsFun = () => { }, tripDetais, callbackEaesbuzz, setIsOpenPayNow } = props;

  const initiFrom = {
    category: "",
    sub_category: "",
    expense_category: "",
    amount: "",
    txn_date: new Date(),
    account_category: "",
    account_sub_category: "",
    account_id: "",
    description: "",
    vendor_type: "",
    vendor_account: "",
    vendor_bank_account: "",
    lr_id: "",
    trip_id: props?.tripId,
    branch_id: "",
    company_id: StorageService.getCompanyId(),
    vehicle_id: "",
    file: [],
  };
  const dispatch = useDispatch();
  const {
    masterData,
    globTripDetails,
    bankDetails,
    setBankDetails,
    modalZIndex,
    setModalZIndex,
    userSettingPermission,
    allMenu
  } = useContext(UserContext);
  const [form, setForm] = useState(initiFrom);
  const [formError, setFormError] = useState("");
  const [freightTypeList, setFreightTypeList] = useState([]);
  const [freigtAccount, setFreigtAccount] = useState([]);
  const [accountList, setAccountList] = useState([]);
  const [isCheck, setIsCheck] = useState(bankDetails ? true : false);
  const [bankAccountList, setBankAccountList] = useState([]);
  const [isLoadding, setIsLoadding] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false)
  const [accountType, setAccountType] = useState();
  const [accountLoading, setAccountLoading] = useState(false);
  const [expenseList, setExpenseList] = useState([]);
  const [expenseDetials, setExpenseDetials] = useState("")
  const [loading, setLoading] = useState(false);
  const [accountAddShow, setAccountAddShow] = useState(false);
  const [bankRequiredDetails, setBankRequiredDetails] = useState({})
  const [payNowAccountCreate, setpayNowAccountCreate] = useState(false);
  const [easeBuzzId, setEaseBuzzId] = useState("")
  const hasLinkPermission = getAllPermissions("Accounts", allMenu, 'label');

  const styleZindex = {
    zIndex: -1,
  };
  useEffect(() => {
    if (masterData) {
      getMasterFreight();

    }
  }, [masterData]);

  useEffect(() => {
    if (freigtAccount.length) {
      getExpenseHandler();
    }
  }, [freigtAccount]);

  useEffect(() => {
    if (!isCheck) {
      setBankDetails("");
      if (form?.vendor_account) {
        setForm({ ...form, vendor_account: "" });
      }
    } else {
      setForm({ ...form, vendor_account: bankAccountList[0]?._id });
      setBankDetails(bankAccountList[0]);
      setFormError((pre) => ({ ...pre, vendor_account: "" }))
    }
  }, [isCheck]);

  useEffect(() => {
    if (bankDetails && form?.category) {
      setForm({ ...form, vendor_account: bankDetails?._id });
      setFormError((pre) => ({ ...pre, vendor_account: "" }))
    }
  }, [bankDetails, form?.category]);

  useEffect(() => {

    if (
      (form?.account_sub_category && form?.account_category &&
        freigtAccount.length && form?.expense_category)
    ) {
      if (form?.account_id == "") {
        getAccountListHandler();
      }
    }
  }, [
    form?.account_sub_category,
    form?.account_category,
    freigtAccount,
    form?.account_id,
    form?.expense_category
  ]);

  useEffect(() => {
    let value = false;

    // 1️⃣ bankRequiredDetails rule
    if (bankRequiredDetails?.vendor_account === true && form?.account_sub_category == 2) {

      value = true;
    }

    // 2️⃣ form/account rules
    if (form?.account_id === "") {
      value = false;
    }

    if (form?.account_sub_category == 27 || form?.account_sub_category == 28) {
      value = true;
    }

    // Final update in one place:
    setIsCheck(value);

  }, [
    bankRequiredDetails,
    form?.account_sub_category,
    form?.account_id,
  ]);

  useEffect(() => {
    if (accountType) {
      setForm({ ...form, account_id: "", vendor_account: "" });

      setBankDetails("");
    }
  }, [accountType]);

  useEffect(() => {
    if (props?.accountList?.length > 0) {
      let list = props?.accountList?.map((i) => {
        return {
          ...i,
          label: i?.bank_name || i?.account_name || i?.upi_id,
          value: i?._id,
        };
      });
      setBankAccountList(list);
    }
  }, [props?.accountList]);

  const getMasterFreight = async () => {
    const payload = {
      type: "add_freight",
    };

    try {

      const detailsAccount = masterData?.own_account_category?.sub_category
        ?.filter((k) => k.id !== 10)
        // ?.reverse()
        ?.map((item) => {
          return {
            label: item?.name,
            value: item?.id,
            category_id: masterData?.own_account_category?.id,
          };
        });

      if (detailsAccount.length) {

        setForm({
          ...form,
          trip_id: props?.tripId,
          category: masterData?.pay_driver?.id,
          sub_category: '',
          account_category: detailsAccount[0]?.category_id,
          account_sub_category: detailsAccount[0]?.value,
        });

        setFreigtAccount(detailsAccount);
        // setFreightTypeList(details);
      }
      // }
    } catch { }
  };



  const getExpenseHandler = async () => {
    try {
      const res = await getAdvanceDriverCategory({
        company_id: StorageService.getCompanyId(),
        category_id: 1,
        sub_category_id: 6
      });

      if (res?.responseCode === 200) {
        const details = res?.data?.categories?.map((item) => {
          return {
            label: item?.name,
            value: item?._id
          };
        });

        setExpenseList(details);
        setExpenseDetials(res?.data)
        setForm({ ...form, expense_category: details[0].value })
      } else {
      }
    } catch (error) {
    }
  };



  const getAccountListHandler = async (newParam = "") => {
    setAccountLoading(true);
    try {
      const res = await getUserAccountList({
        company_id: StorageService?.getCompanyId(),
        category_id: parseInt(form?.account_category),
        sub_category_id: parseInt(form?.account_sub_category),
        firm_id: tripDetais?.interfirm == 1 ? tripDetais?.vehicle_firm?._id : tripDetais?.firm_id?._id
      });

      if (res?.responseCode === 200) {
        const accountListData = res?.data?.account_list || [];

        const details = accountListData.map((item) => ({
          ...item,
          label: item?.name,
          value: item?._id,
        }));

        setAccountList(details);

        if (details.length > 0) {
          const lastItem = details[details.length - 1];
          handleOnChange("account_id", newParam == "new" ? lastItem?.value : details[0].value);
          setBankRequiredDetails(newParam == "new" ? lastItem : details[0])

          if (form?.account_sub_category == 28) {
            setEaseBuzzId(details[0]?.eb_account_id)
          } else {
            setEaseBuzzId("")
          }

          if (parseInt(form?.account_sub_category) === 2) {
            if (bankAccountList?.length > 0) {
              setForm((prev) => ({
                ...prev,
                vendor_bank_account: bankDetails ? bankDetails?._id : bankAccountList[0]._id,
                account_id: newParam == "new" ? lastItem?.value : details[0].value

              }));

              // setBankDetails(bankAccountList[0]);
            } else {
              setForm((prev) => ({
                ...prev,
                vendor_bank_account: '',
                account_id: newParam == "new" ? lastItem?.value : details[0].value
              }));


              setBankDetails('');
            }
          } else {
            setForm((prev) => ({
              ...prev,
              vendor_bank_account: '',
              account_id: newParam == "new" ? lastItem?.value : details[0].value
            }));
            setBankDetails('');
          }
        } else {
          setForm((prev) => ({
            ...prev,
            account_id: '',
            vendor_bank_account: '',
          }));
          setBankDetails('');
          if (details.length == 0 && form?.account_sub_category == 28) {
            setpayNowAccountCreate(true)
          }
        }
      } else {
        setAccountList([]);
      }
    } catch (error) {
      setAccountList([]);
    } finally {
      setAccountLoading(false);
    }
  };


  const handleOnChange = async (name, value) => {
    const stateObj = {
      ...form,
      [name]: value,
    };
    setForm(stateObj);

    if (!!formError) {
      const validationResult = await utils.checkFormError(
        { ...stateObj },
        errorSchema.addOwnChargeSchema
      );
      if (validationResult === true) {
        setFormError("");
      } else {
        setFormError(validationResult);
      }
    }
  };

  const onSubmitFreight = async (approve) => {
    const validationResult = await utils.checkFormError(
      { ...form, isCheck: isCheck, },
      errorSchema.addPayDriverSchema
    );

    const payload = {
      type: form?.category ? parseInt(form?.category) : "",
      expense_category: form?.expense_category,
      amount: form?.amount,
      date: utils.convertToISO(form?.txn_date, true),
      account_category: form?.account_category
        ? parseInt(form?.account_category)
        : "",
      account_sub_category: form?.account_sub_category
        ? parseInt(form?.account_sub_category)
        : "",
      account_id: form?.account_id ? form?.account_id : "",
      description: form?.description,
      vendor_bank_account: bankDetails ? bankDetails?._id : "",
      lr_id: "",
      trip_id: props.tripId,
      branch_id: globTripDetails?.branch_id?._id,
      company_id: form?.company_id,
      vehicle_id: globTripDetails?.vehicle_id?._id,
      is_approval: approve,
      file: form?.file,
    };

    if (validationResult === true) {

      if (approve == 0 && form?.account_sub_category == 28) {
        callbackEaesbuzz(
          easeBuzzId,
          form?.amount,
          {
            vendor_bank_account: {
              account_name: bankDetails?.account_name,
              account_number: bankDetails?.account_number,
              account_type: bankDetails?.account_type,
              bank_name: bankDetails?.bank_name,
              ifsc_code: bankDetails?.ifsc_code,
              upi_id: bankDetails?.upi_id
            }
          },
          payload
        );

        setIsOpenPayNow(true)
        return
      }

      approve == 0 ? setIsLoadding(true) : setIsLoadingSave(true);
      try {
        const res = await dispatch(addDriverTransaction(payload));

        if (res?.payload?.responseCode === 200) {
          setIsLoadding(false);
          setIsLoadingSave(false);
          callBackFreight();
          clearClose()
          setBankDetails('')
          toast.success("Created");
        } else {
          setIsLoadding(false);
          setIsLoadingSave(false);
          toast.error("Somthing Wrong");
        }
      } catch {
        setIsLoadding(false);
        setIsLoadingSave(false);
        toast.error("Somthing Wrong");
      }
    } else {
      setFormError(validationResult);
      setIsLoadding(false);
      setIsLoadingSave(false);
    }
  };

  const modifyProps = {
    ...props,
    onSubmit: onSubmitFreight,
    isLoadding: isLoadding,
    disabled: isLoadding,
    isLoadingSave: isLoadingSave
  };

  const handleFileChange = async (e) => {
    if (
      e?.target?.files[0]?.type === "image/gif" ||
      e?.target?.files[0]?.type === "image/jpeg" ||
      e?.target?.files[0]?.type === "image/png"
    ) {
      setLoading(true);
      try {
        const formData = new FormData();
        formData.append("file", e?.target?.files[0]);
        const res = await uploadFiles(formData);
        if (res?.responseCode === 200) {
          var fileArray = [];
          fileArray.push(...form?.file, {
            filename: res?.data?.filename,
            path: res?.data?.path,
          });
          handleOnChange("file", fileArray);
          // setFormValue((s) => ({ ...s, file: fileArray }));
          setLoading(false);
          toast.success("Document added ");
        }
      } catch (error) {
        setLoading(false);
      }
    } else {
      toast.error("Invalid file, choose jpeg/png images");
    }
  };

  const documentRemove = (index) => {
    const newFromIput = [...form?.file];

    newFromIput.splice(index, 1);

    setForm({ ...form, file: newFromIput });
  }

  const clearClose = () => {
    setBankDetails('')
    closeModal();
  }


  const addAccountHandle = (tab) => {

    const returnTab = tab == 3 ? 1 : tab == 2 ? 2 : tab == 14 ? 4 : ""

    setAccountAddShow(returnTab);

  };
  const isAddButtonVisible = Boolean(
    hasLinkPermission?.canCreate &&
    ["14", "2", "3"].includes(String(form?.account_sub_category))
  );

  const callBackAddAccount = () => {
    getAccountListHandler("new")
  }

  let AddTransactionAccountModal = {
    isOpen: accountAddShow,
    closeModal: (e) => setAccountAddShow(false),
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Add Account ",
    // headerPart: true,
    footerPart: true,
    submitTitle: "Add Account",
    callBackAddAccount: callBackAddAccount,
    branchFirmId: tripDetais?.firm_id
  }

  let payNowAccountProps = {
    isOpen: payNowAccountCreate,
    closeModal: (e) => {
      setpayNowAccountCreate(false)
      setAccountType(3);
      setForm((pre) => ({ ...pre, account_sub_category: 3 }));
    },
    modalMainClass: "_dashCommon_Modal _mdModal",
    modalTitle: "Pay Now ",
    // headerPart: true,
    footerPart: true,
    submitTitle: "Create Account",
    callBackAddAccount: callBackAddAccount
  }

  return (
    <div>
      <div
        className={`offcanvas offcanvas-end common_offCanvas ${isOpen ? "show" : ""
          }`}
        tabIndex={-1}
        style={{
          visibility: isOpen ? "visible" : "hidden",
          display: modalZIndex ? "none" : "",
        }}
      >
        {isOpen && (
          <>
            <div className="offcanvas-header headWith_back">
              <h5 className="offcanvas-title">Pay Driver</h5>
              <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={clearClose}>
                <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" >
                  <path
                    d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                    fill="black"
                  />
                </svg>
              </CrossButton>
            </div>

            {/* {expenseList?.length > 0 ? ( */}
            <>
              <div className="offcanvas-body">
                <div className="_lrCl_offCavBody __otr_expCanva">
                  <div className="_othrExp_recBx">
                    <div className="_clPay_flex">
                      <div className="singleDiv">
                        <CommonDatePicker
                          name="date"
                          label="Transaction Date"
                          startDate={form?.txn_date}
                          setStartDate={(data) => {
                            handleOnChange("txn_date", data);
                          }}
                          error={formError?.txn_date}
                          focus={!!formError?.txn_date}
                          maxDate={new Date()}
                        />
                      </div>
                      <div className="singleDiv">
                        <CommonInput
                          type="text"
                          label="Category"
                          placeholder="Category"
                          name="expense_category"
                          value={
                            form?.expense_category
                              ? expenseList?.find(
                                (i) => i.value == form?.expense_category
                              ).label : ""
                          }
                          disabled={true}
                        />

                      </div>
                      <div className="singleDiv">
                        <CommonInput
                          type="text"
                          label="Description"
                          placeholder="Description"
                          name="description"
                          value={form?.description}
                          onChange={({ target: { name, value } }) => {
                            handleOnChange(name, value);
                          }}
                          focus={!!formError?.description}
                          error={formError.description}
                        />
                      </div>
                      <div className="singleDiv">
                        <CommonInput
                          type="text"
                          label="Amount (₹)"
                          placeholder="Amount"
                          name="amount"
                          className="__rupeeSymbol"
                          rupeeSymbol={true}
                          value={form.amount}
                          onChange={({ target: { name, value } }) => {
                            // if (validateInput(value ? value : 0)) {
                            handleOnChange(name, value);

                            // }
                          }}
                          maxLength={10}
                          onKeyDown={handleKeyDown}
                          focus={!!formError?.amount}
                          error={formError.amount}
                        />
                      </div>



                    </div>
                  </div>


                  <div className="_othrExp_recBx">
                    <div className="_clPay_flex">

                      <div className="singleDiv">
                        <div className="_payMode_hed">
                          <h4>Payment Mode</h4>
                          {freigtAccount.map((i) => (
                            <button
                              key={i?.value}
                              className={`_baseSpan ${i?.value == form?.account_sub_category
                                ? ""
                                : "_bspDisable"
                                }`}
                              disabled={accountLoading}
                              name="account_sub_category"
                              value={i.value}
                              onClick={({ target: { name, value } }) => {
                                handleOnChange(name, value);
                                setAccountType(value);
                              }}
                            >
                              {i.label}
                            </button>
                          ))}
                          {/* <span className='_baseSpan _bspDisable'>Bank Transfer</span> */}
                        </div>
                      </div>
                      {form?.account_sub_category != "10" && (
                        <>
                          {!accountLoading ? <div className="singleDiv">
                            <CustomSelect
                              label="Select Account"
                              name="account_id"
                              onSelect={(data) => {
                                handleOnChange("account_id", data.value);
                                setBankRequiredDetails(data)

                              }}
                              value={
                                form?.account_id
                                  ? accountList?.find(
                                    (i) => i.value == form?.account_id
                                  ) || { label: "", value: "" }
                                  : { label: "", value: "" }
                              }
                              options={accountList}
                              focus={!!formError?.account_id}
                              error={formError.account_id}
                              isAddButton={isAddButtonVisible}
                              addButtonAction={() => addAccountHandle(form?.account_sub_category)}
                            />
                          </div> : <SkeletonInput isLoading={accountLoading} />}
                        </>
                      )}

                      {form?.account_sub_category == 2 && (
                        <div className="singleDiv">
                          Driver {globTripDetails?.driver_id?.name} Account
                        </div>
                      )}
                      {(form?.account_sub_category == 2 || form?.account_sub_category == 27 || form?.account_sub_category == 28) && (
                        <div>
                          <input
                            type="checkbox"
                            id="vehicle1"
                            name="vehicle1"
                            // value="Bike"
                            checked={isCheck}
                            disabled={form?.account_sub_category == 27 || form?.account_sub_category == 28 || bankRequiredDetails?.vendor_account === true}
                            onChange={({ target: { name, checked } }) => {
                              setIsCheck(checked);
                              handleOnChange("isCheck", checked);
                            }}

                          />
                          <label for="vehicle1"> Select Driver Bank Account</label>
                          <br />
                        </div>
                      )}
                      {(form?.account_sub_category == 2 || form?.account_sub_category == 27 || form?.account_sub_category == 28) && (
                        <>
                          <div
                            className="singleDiv"
                            onClick={() => {
                              venderDetailsFun({ vender_type: 3, vender_id: globTripDetails?.driver_id?._id })
                              console.log("venderrrrr", { vender_type: 3, vender_id: globTripDetails?.driver_id?._id })
                              // props?.setIsOpenFreight(false);
                              setModalZIndex(-1);
                              props?.setCanvasOpen(true);

                            }}
                          >
                            <CustomSelect
                              label="Select Bank Account"
                              options={bankAccountList}
                              openList={false}
                              value={
                                bankDetails
                                  ? bankAccountList?.find(
                                    (i) => i?.value === bankDetails?._id
                                  )
                                  : { label: "", value: "" }
                              }
                              focus={!!formError?.vendor_account}
                              error={formError.vendor_account}
                            />
                            {/* <p className="_bottomPLine">
                              Optional
                            </p> */}
                          </div>

                        </>

                      )}
                    </div>
                  </div>
                  <div className="_othrExp_recBx">
                    <div className="_clPay_flex">
                      <div className="singleDiv">
                        <div className="_attatchmentBxs">
                          <div className="__addExp_fileBx">
                            <h4>Attachment</h4>


                            {/* <input
                              type="file"
                              id="_fileUpload"
                              onChange={(e) => handleFileChange(e)}
                              disabled={loading || form?.file?.length >= 5}
                            /> */}
                            <input
                              type="file"
                              id="_fileUpload"
                              onClick={(e) => {
                                if (form?.file?.length >= 5) {
                                  e.preventDefault(); // stop opening file dialog
                                  toast.error("You can upload only 5 files");
                                }
                              }}
                              onChange={(e) => handleFileChange(e)}
                            />
                            <label htmlFor="_fileUpload" className="_uploadBtn">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="19"
                                viewBox="0 0 20 19"
                                fill="none"
                              >
                                <path
                                  d="M5 0C6.28846 7.44425e-05 7.52716 0.497542 8.45778 1.38866C9.38839 2.27978 9.93908 3.49575 9.995 4.783L10 5V16C10.0008 16.7809 9.69698 17.5313 9.15323 18.0918C8.60948 18.6523 7.86861 18.9787 7.08804 19.0016C6.30747 19.0245 5.54873 18.7422 4.97303 18.2145C4.39733 17.6869 4.05006 16.9556 4.005 16.176L4 16V6C4.00028 5.74512 4.09788 5.49997 4.27285 5.31463C4.44782 5.1293 4.68695 5.01776 4.94139 5.00283C5.19584 4.98789 5.44638 5.07067 5.64183 5.23426C5.83729 5.39785 5.9629 5.6299 5.993 5.883L6 6V16C6.00028 16.2549 6.09788 16.5 6.27285 16.6854C6.44782 16.8707 6.68695 16.9822 6.94139 16.9972C7.19584 17.0121 7.44638 16.9293 7.64183 16.7657C7.83729 16.6021 7.9629 16.3701 7.993 16.117L8 16V5C8.00075 4.21909 7.69698 3.46867 7.15323 2.90818C6.60948 2.34769 5.86861 2.02132 5.08804 1.9984C4.30747 1.97548 3.54873 2.25784 2.97303 2.78546C2.39733 3.31309 2.05006 4.0444 2.005 4.824L2 5V14C1.99972 14.2549 1.90212 14.5 1.72715 14.6854C1.55218 14.8707 1.31305 14.9822 1.05861 14.9972C0.804163 15.0121 0.553621 14.9293 0.358167 14.7657C0.162714 14.6021 0.0371036 14.3701 0.00699997 14.117L0 14V5C0 3.67392 0.526784 2.40215 1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0ZM13 14H15C15.2549 14.0003 15.5 14.0979 15.6854 14.2728C15.8707 14.4478 15.9822 14.687 15.9972 14.9414C16.0121 15.1958 15.9293 15.4464 15.7657 15.6418C15.6021 15.8373 15.3701 15.9629 15.117 15.993L15 16H13C12.7451 15.9997 12.5 15.9021 12.3146 15.7272C12.1293 15.5522 12.0178 15.313 12.0028 15.0586C11.9879 14.8042 12.0707 14.5536 12.2343 14.3582C12.3979 14.1627 12.6299 14.0371 12.883 14.007L13 14ZM13 10H18.5C18.7549 10.0003 19 10.0979 19.1854 10.2728C19.3707 10.4478 19.4822 10.687 19.4972 10.9414C19.5121 11.1958 19.4293 11.4464 19.2657 11.6418C19.1021 11.8373 18.8701 11.9629 18.617 11.993L18.5 12H13C12.7451 11.9997 12.5 11.9021 12.3146 11.7272C12.1293 11.5522 12.0178 11.313 12.0028 11.0586C11.9879 10.8042 12.0707 10.5536 12.2343 10.3582C12.3979 10.1627 12.6299 10.0371 12.883 10.007L13 10ZM13 6H18.5C18.7549 6.00028 19 6.09788 19.1854 6.27285C19.3707 6.44782 19.4822 6.68695 19.4972 6.94139C19.5121 7.19584 19.4293 7.44638 19.2657 7.64183C19.1021 7.83729 18.8701 7.9629 18.617 7.993L18.5 8H13C12.7451 7.99972 12.5 7.90212 12.3146 7.72715C12.1293 7.55218 12.0178 7.31305 12.0028 7.05861C11.9879 6.80416 12.0707 6.55362 12.2343 6.35817C12.3979 6.16271 12.6299 6.0371 12.883 6.007L13 6ZM13 2H18.5C18.7549 2.00028 19 2.09788 19.1854 2.27285C19.3707 2.44782 19.4822 2.68695 19.4972 2.94139C19.5121 3.19584 19.4293 3.44638 19.2657 3.64183C19.1021 3.83729 18.8701 3.9629 18.617 3.993L18.5 4H13C12.7451 3.99972 12.5 3.90212 12.3146 3.72715C12.1293 3.55218 12.0178 3.31305 12.0028 3.05861C11.9879 2.80416 12.0707 2.55362 12.2343 2.35817C12.3979 2.16271 12.6299 2.0371 12.883 2.007L13 2Z"
                                  fill="#1956F6"
                                />
                              </svg>
                              <span>{loading ? "Uploadding" : "Add File"}</span>
                            </label>
                            {formError?.file && (
                              <span className="input_drop_error">
                                {formError?.file}
                              </span>
                            )}
                          </div>
                          <div className="img_fnex_src">
                            {form?.file?.length > 0 &&
                              form?.file?.map((el, index) => {
                                return (
                                  <>
                                    <div className='pos-relative'>
                                      <img className='_pdfIcon_sigxe'
                                        src={`${masterData?.s3_url}${el?.path}`}
                                        alt=""
                                      />
                                      <span className='_clDel_icon'>
                                        <IoCloseCircle onClick={() => documentRemove(index)} />
                                      </span>
                                    </div>
                                  </>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* </div>
              </div> */}

                </div>
              </div>
              <div className="offcanvas-footer">
                {/* <button
                      className=" _submitOn_modal"
                      disabled={isLoadding}
                      onClick={() => onSubmitFreight(1)}
                    >
                      Approve
                    </button>
                    <button
                      className=" _submitOn_modal"
                      disabled={isLoadding}
                      onClick={() => onSubmitFreight(0)}
                    >
                      Save
                    </button> */}


                {form?.account_sub_category != 27 && <>
                  {(userSettingPermission?.trip_payment_approval != 1 || bankRequiredDetails?.trip_payment_approval != 1) && <LoaderButton
                    onClick={() => onSubmitFreight(0)}
                    isLoading={isLoadding}
                    isLoadingText="Processing..."
                    className="_submitOn_modal"
                    disabled={isLoadding}
                  >
                    {form?.account_sub_category == 28 ? "Pay Now" : "Save"}
                  </LoaderButton>}</>}
                <LoaderButton
                  onClick={() => onSubmitFreight(1)}
                  isLoadingText="Processing..."
                  className="_submitOn_modal_white"
                  loaderClass="custom-spinner"
                  disabled={isLoadingSave}
                  isLoading={isLoadingSave}
                >
                  Send for Approval
                </LoaderButton>
              </div>
            </>
            {/* ) : (
              <Loading />
            )} */}
          </>
        )
        }
      </div >
      <div className={isOpen ? "offBack_drop" : ""}></div>
      {accountAddShow && <AddAccountingAccount {...AddTransactionAccountModal} />}
      {payNowAccountCreate && <PayNowAccountNotifyModal {...payNowAccountProps} />}
    </div >
  );
};

export default PayDriver;
